module.exports = __webpack_public_path__ + "media/images/doorsticker1-fb7617dfc748a7f2f39025384be8f2a0.jpeg";